import Dexie from "dexie";
const NAME = "snort-system";
const VERSION = 2;
const STORES = {
    users: "++pubkey, name, display_name, picture, nip05, npub",
    relayMetrics: "++addr",
    userRelays: "++pubkey",
    events: "++id, pubkey, created_at",
};
export class SnortSystemDb extends Dexie {
    ready = false;
    users;
    relayMetrics;
    userRelays;
    events;
    constructor() {
        super(NAME);
        this.version(VERSION).stores(STORES);
    }
    isAvailable() {
        if ("indexedDB" in window) {
            return new Promise(resolve => {
                const req = window.indexedDB.open("dummy", 1);
                req.onsuccess = () => {
                    resolve(true);
                };
                req.onerror = () => {
                    resolve(false);
                };
            });
        }
        return Promise.resolve(false);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxLQUFnQixNQUFNLE9BQU8sQ0FBQztBQUVyQyxNQUFNLElBQUksR0FBRyxjQUFjLENBQUM7QUFDNUIsTUFBTSxPQUFPLEdBQUcsQ0FBQyxDQUFDO0FBRWxCLE1BQU0sTUFBTSxHQUFHO0lBQ2IsS0FBSyxFQUFFLG9EQUFvRDtJQUMzRCxZQUFZLEVBQUUsUUFBUTtJQUN0QixVQUFVLEVBQUUsVUFBVTtJQUN0QixNQUFNLEVBQUUsMEJBQTBCO0NBQ25DLENBQUM7QUFFRixNQUFNLE9BQU8sYUFBYyxTQUFRLEtBQUs7SUFDdEMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNkLEtBQUssQ0FBd0I7SUFDN0IsWUFBWSxDQUF1QjtJQUNuQyxVQUFVLENBQXNCO0lBQ2hDLE1BQU0sQ0FBcUI7SUFFM0I7UUFDRSxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDWixJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBRUQsV0FBVztRQUNULElBQUksV0FBVyxJQUFJLE1BQU0sRUFBRTtZQUN6QixPQUFPLElBQUksT0FBTyxDQUFVLE9BQU8sQ0FBQyxFQUFFO2dCQUNwQyxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQyxDQUFDLENBQUM7Z0JBQzlDLEdBQUcsQ0FBQyxTQUFTLEdBQUcsR0FBRyxFQUFFO29CQUNuQixPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQ2hCLENBQUMsQ0FBQztnQkFDRixHQUFHLENBQUMsT0FBTyxHQUFHLEdBQUcsRUFBRTtvQkFDakIsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO2dCQUNqQixDQUFDLENBQUM7WUFDSixDQUFDLENBQUMsQ0FBQztTQUNKO1FBQ0QsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2hDLENBQUM7Q0FDRiJ9